import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 · La capa Protectora, el Biofilm',
  desc: 'Por qué fallaste antes y qué cambia ahora',
  value: 'Valor $12.000'
}, {
  icon: '📗',
  title: 'TOMO 2 · 72 Horas Para bajar tu Dolor',
  desc: 'Alivio inmediato sin químicos agresivos',
  value: 'Valor $12.000'
}, {
  icon: '📙',
  title: 'TOMO 3 · Nutrición Anti-Hongos',
  desc: 'Qué comprar en el supermercado',
  value: 'Valor $10.000'
}, {
  icon: '📕',
  title: 'TOMO 4 · El Eje Intestino-Vagina',
  desc: 'Cortar la fuente de re-infección de raíz',
  value: 'Valor $12.000'
}, {
  icon: '📓',
  title: 'TOMO 5 · Suplementación Estratégica',
  desc: 'Los 5 antifúngicos naturales más potentes',
  value: 'Valor $10.000'
}, {
  icon: '📔',
  title: 'TOMO 6 · Blindaje Para extinguir el Hongo',
  desc: 'Que no vuelva nunca más',
  value: 'Valor $10.000'
}];
export function ProductSection() {
  return <section className="w-full bg-[#F8F5FC] px-6 py-16" data-id="element-262">
      <div className="max-w-2xl mx-auto" data-id="element-263">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-264">
          TODO LO QUE RECIBÍS HOY
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-8" data-id="element-265">
          No es un libro. Es un sistema de 6 tomos.
        </p>

        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Product CTA',
        value: 19990,
        currency: 'ARS'
      })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[16px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)] mb-12" data-id="element-266">
          🔓 QUIERO EL MÉTODO pH-ZERO
        </a>

        <div className="flex flex-col gap-4" data-id="element-267">
          {tomos.map((tomo, i) => <div key={i} className="bg-white rounded-[16px] p-5 shadow-[0_4px_24px_rgba(0,0,0,0.08)] border-l-4 border-brand-violet flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-268">
              <div className="flex-1 flex items-start gap-3" data-id="element-269">
                <span className="text-2xl flex-shrink-0" data-id="element-270">{tomo.icon}</span>
                <div data-id="element-271">
                  <p className="text-brand-text font-bold text-[15px] leading-tight mb-1" data-id="element-272">
                    {tomo.title}
                  </p>
                  <p className="text-brand-muted text-[13px] leading-snug" data-id="element-273">
                    {tomo.desc}
                  </p>
                </div>
              </div>
              <div className="inline-flex items-center px-3 py-1 bg-brand-violet/10 text-brand-violet text-[12px] font-bold rounded-full whitespace-nowrap self-start sm:self-auto" data-id="element-274">
                {tomo.value}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}